import { render, staticRenderFns } from "./NonNewtonianViz.vue?vue&type=template&id=27e59c92&scoped=true"
import script from "./NonNewtonianViz.vue?vue&type=script&lang=js"
export * from "./NonNewtonianViz.vue?vue&type=script&lang=js"
import style0 from "./NonNewtonianViz.vue?vue&type=style&index=0&id=27e59c92&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e59c92",
  null
  
)

export default component.exports